export const LINT_SERVICE_ENDPOINT = window.env.VUE_APP_LINT_SERVICE_DOMAIN;

// Resource paths
export const MODULE_RESOURCE_PATH = '/module';
